export default __webpack_public_path__ + "static/media/Body-Grotesque-Fit-Bold.670849d7.otf";